import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { InsuranceTypeService } from 'app/modules/vehicle-inventory/services/table-management/InsuranceType.service';
import { InsuranceComponentService } from 'app/modules/vehicle-inventory/services/table-management/insuranceComponent.service';
import { ProviderService } from 'app/rest/provider.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';

@Component({
    selector: 'app-insurance-comp-form',
    templateUrl: './insurance-comp-form.component.html',
    styleUrls: ['./insurance-comp-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InsuranceCompFormComponent extends EntityFormComponent<Rest.InsuranceComponent>implements OnInit {

  startDate: Date;
  endDate: Date;
  constructor(
    private insuranceComponentService: InsuranceComponentService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    private userTime: UserTimePipe

) {
    super(insuranceComponentService, notificationsService, i18n, authenticationService);
}

  ngOnInit(): void {

    
  }

  beforeShow(): void {
    this.startDate = this.entity.startDate ? this.userTime.utcToCalendarDate(this.entity.startDate) : null;;
    this.endDate = this.entity.endDate ? this.userTime.utcToCalendarDate(this.entity.endDate) : null;
  }

  onKeyDownDecimal(event: any) {
    var pressedKey = event.key;
    const keyMap = new Map<number, string>();
    keyMap.set(110, ",");
    keyMap.set(190, ",");
    const { keyCode } = event;
    if (!event.target.value.includes(',') && (keyMap.has(keyCode) || pressedKey === ',')) {
      event.preventDefault();
      event.target.value += ',';
    }
  }

  beforeSave(): void {
    this.entity.startDate = this.startDate != null ? new Date(this.userTime.toUTCISOString(this.startDate)): null;
    this.entity.endDate = this.endDate != null ? new Date(this.userTime.toUTCISOString(this.endDate)): null;

  }
  
}
